import styled from 'styled-components';
import Content from 'js/components/core/Modal/Content';

export default styled(Content)`
  text-align: center;
`;
